import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.some.js";
import Drawer from 'primevue/drawer';
export default {
  components: {
    Drawer
  },
  computed: {
    ShowAppDevTools() {
      return process.env.NODE_ENV === 'development';
    },
    globalLoading() {
      return Object.values(this.$state.appGlobalLoading).some(l => l);
    },
    showApplicationTools() {
      return {
        navigation: typeof this.$route.meta.navigation === 'function' ? this.$route.meta.navigation() : this.$route.meta.navigation,
        topbar: typeof this.$route.meta.topbar === 'function' ? this.$route.meta.topbar() : this.$route.meta.topbar
      };
    }
  }
};